import { AssetTypeFilter, type InsightDefinition } from '@/types/dashboard-types'

import {
  buildHistoryGraphControls,
  HistoryGraphCaption,
  createHistoryGraphDisplay,
  createHistoryGraphFooter,
  isHistoryGraphValid,
  loadWithTemperatureLimits,
  type HistoryGraphParams,
} from '../historyGraph/HistoryGraph'
import type { AssetHistory } from '../historyGraph/types'

const InStoreHistoryGraph: InsightDefinition<HistoryGraphParams, AssetHistory> = {
  active: true,
  slug: 'asset/in-store-history-graph',
  category: 'asset',
  name: 'Fresh InStore Temperature Graph',
  description: 'Display Fresh InStore asset temperature graph for a given date range',
  defaultWidth: 'full',
  defaultHeight: { lg: 550, md: 550, sm: 550 },
  defaultAspectRatio: 16 / 9,

  configuration: {
    controls: buildHistoryGraphControls(AssetTypeFilter.InStore, 'Location'),
    isValid: isHistoryGraphValid,
  },

  load: loadWithTemperatureLimits,

  Display: createHistoryGraphDisplay({ flattenZoneLegend: true }),

  Caption: HistoryGraphCaption,

  Footer: createHistoryGraphFooter({ showZoneCount: false }),
}

export default InStoreHistoryGraph
